var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 285,
    viewBox: "0 0 337 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.875 11.9561C157.607 -2.41199 178.461 -2.41202 187.192 11.9561L331.59 249.572C340.669 264.512 329.914 283.634 312.432 283.634L23.6357 283.634C6.1533 283.634 -4.60154 264.512 4.47751 249.572L148.875 11.9561Z",
    stroke: "#7057DB",
    strokeWidth: 2.35989
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerA);
export default __webpack_public_path__ + "static/media/marker--a.89c36aa71fc9c3cf43a5680ee2402ad0.svg";
export { ForwardRef as ReactComponent };